import { NavSectionEnum } from "./nav-section.enum";

/**
 * Used to store information about the application state for the layout components (such as the header and navbar).
 */
export class PageInfo {

	public PageTitle: string = "";

	public PageDescription: string = "";

	public CurrentSection: NavSectionEnum = NavSectionEnum.Home;
	
	public ShowHeaderUserPanel: boolean = true;

	public ShowHeaderHelpPanel: boolean = true;

}